import React from 'react'
import ReactDOM from 'react-dom'
import OnlineNumberUpdater from '../../core/classes/OnlineNumberUpdater'
import ReviewSlider from './component/ReviewSlider'
import Listener from '../../core/watcher/Listener'
import './_style.scss'

Listener.onLoadDOM(() => {
   new OnlineNumberUpdater({selector: '.js-onlineMarker'})

   const images = document.reviewImages
   const reviewSliderSettings = {
      autoplay: true,
      infinite: true,
      slidesToShow: images.length < 4 ? images.length : 3.1,
      slidersToScroll: 1,
      autoplaySpeed: 3500,
      pauseOnDotsHover: true,
      dots: true,
      pauseOnFocus: true,
      pauseOnHover: true,
      responsive: [
         {
            breakpoint: 992,
            settings: {
               dots: false,
               slidesToShow: images.length < 3 ? images.length : 2.15,
            },
         },
      ],
   }

   const root = document.getElementById('reviewPhotoSlider')
   if (root) {
      ReactDOM.render(<ReviewSlider images={images} settings={reviewSliderSettings} />, root)
   }
})